import {
    METERS_IN_MILE,
    METERS_IN_KILOMETER
} from './constants';

export const convertMetersToMiles = meters => meters / METERS_IN_MILE;
export const convertMilesToMeters = miles => miles * METERS_IN_MILE;
export const convertMetersToKilometers = meters => meters / METERS_IN_KILOMETER;
export const convertKilometersToMeters = kilometers => kilometers * METERS_IN_KILOMETER;
export const convertMilesToKilometers = miles => convertMetersToKilometers(
    convertMilesToMeters(miles)
);
export const convertKilometersToMiles = kilometers => convertMetersToMiles(
    convertKilometersToMeters(kilometers)
);
